module.exports = __webpack_public_path__ + "img/image-commitment.afe54e9c.jpg";